<template>
  <div class="breadcrumb-wrap">
    <a-breadcrumb separator=">" class="custom-breadcrumb">
      <a-breadcrumb-item v-for="(item, index) in navList" :key="index">
        <img v-if="index === 0" src="../../assets/images/common/形状@3x.png" class="return-back" alt="">
        <!-- <icon-font class="fs12" type="icon-cancel1f" v-if="index === 0"></icon-font> -->
        <!-- <a-icon v-if="index === 0" type="rollback" /> -->
        <span @click="goTo(item, index)">{{item.text}}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  props: {
    navList: {
      type: [Array, Boolean],
      default: function () {
        return []
      }
    }
  },
  methods: {
    goTo (item, index) {
      if (index === this.navList.length - 1) {
        return
      }

      let path = item.path

      if (index === 0) {
        path = '/index'
      }

      this.$router.push(path)
    }
  }
}
</script>

<style lang="less">
@import "../../assets/style/index";
.breadcrumb-wrap{
  .custom-breadcrumb{
    width: 1430px;
    margin: 0 auto 0;
    padding: 30px 0 33px 0;
    color: #fff;

    .return-back{
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }

    .anticon{
      width: 24px;
      height: 24px;
      background-color: #fff;
      color: #333;
      border-radius: 50%;
      line-height: 28px;
      font-size: 14px;
      vertical-align: text-bottom;
    }
    &>span:first-child .ant-breadcrumb-link{
      font-size: 22px;
      line-height: 24px;
    }
    .ant-breadcrumb-separator, .ant-breadcrumb-link, &>span .ant-breadcrumb-link{
      color: @breadColor;
    }
    &>span .ant-breadcrumb-link, .ant-breadcrumb-separator{
      font-size: 16px;
    }
    .ant-breadcrumb-link{
      &:hover{
        cursor: pointer;
      }
    }
  }
}
  
</style>